import * as TinyPubSub from './TinyPubSub';

document.addEventListener('keydown', (e) => {
  if (e.keyCode === 27) TinyPubSub.publish('windowEscKeyPressed');
  if (e.keyCode === 37) TinyPubSub.publish('windowLeftKeyPressed');
  if (e.keyCode === 39) TinyPubSub.publish('windowRightKeyPressed');
  if (e.keyCode === 38) TinyPubSub.publish('windowUpKeyPressed');
  if (e.keyCode === 40) TinyPubSub.publish('windowDownKeyPressed');
  if (e.keyCode === 13) TinyPubSub.publish('windowEnterKeyPressed');
});
